import router from '@/router';
import { getQueryString, setUserInfo } from '@/utils';
import { loginByUserName } from '@/api/home/login/api';

// 第三方系统嵌入登录
export async function _loginByUserName() {
  const username = getQueryString('u');
  const { code, data, authorization } = await loginByUserName({
    username
  });
  if (code === 0) {
    setUserInfo(data, authorization);
    router.replace({
      path: '/redirect' + router.currentRoute.fullPath
    });
  }
}